import { Link } from 'react-router-dom';
import logoImage from '../../assets/logo.png';
import './Logo.css';

export default function Logo() {
  return (
    <Link to="/" className="logo-container">
      <div className="logo">
        <img src={logoImage} alt="Awaken Logo" />
      </div>
      <h1>Awaken</h1>
    </Link>
  );
} 